import React from 'react';
import { Drawer, Image, Typography } from 'antd';
import { UserIcon } from '../Icon';
import Client from '../DrawerContent/Client';
import Artist from '../DrawerContent/Artist';
import User from '../DrawerContent/User';
import { is } from '../../services/helpers';

const { Text, Title } = Typography;

const UserDrawer = ({ handleDrawerClose, visible, placement = "right", usersDetailsData, status }: any) => (
  <>
    <Drawer
      title=""
      placement={placement}
      width={584}
      onClose={handleDrawerClose}
      visible={visible}
    >
      {!is.request(status) ? (
        <div className="details-container">
          <div className="user-details">
            <div style={{ display: 'flex' }}>
              <Image
                width={174}
                height={152}
                src={usersDetailsData?.avatar}
              />
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <div>
                  <Title className="user-details-name">{usersDetailsData?.name}</Title>
                  <Text className="user-details-nickname">{usersDetailsData?.nickname}</Text>
                </div>
                <Text className="user-details-email">{usersDetailsData?.email}</Text>
              </div>
            </div>
            <div className="user-type">
              <UserIcon color="#fff" opacity={1} />
              <Text>{usersDetailsData?.type?.toUpperCase()}</Text>
            </div>
          </div>
          {usersDetailsData?.type === 'artist' ? (
            <Artist usersDetailsData={usersDetailsData} />
          ) : usersDetailsData?.type === 'client' ? (
            <Client usersDetailsData={usersDetailsData} />
          ) : (
            <User usersDetailsData={usersDetailsData} />
          )}
        </div>
      ) : <div>Loading....</div>}
    </Drawer>
  </>
);

export default UserDrawer;
